import { useState } from "react";
import "./faq.scss";
import FaqItem from "./FaqItem";
import { useGetAllFaqsQuery } from "../api/faqApiSlice";
import LoadingSpinner from "../../components/loader/Loader";

const FaqList = () => {
  const [showAnswer, setShowAnswer] = useState(null);

  const { data: faqs, isLoading } = useGetAllFaqsQuery(undefined, {
    pollingInterval: 15000,
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
  });

  const toggleAnswer = (index) => {
    setShowAnswer((prevIndex) => (prevIndex === index ? null : index));
  };

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="main_wrapper ">
      <div className="container">
        <header className="main-header">
          <h1> Frequently Asked Questions</h1>
        </header>
        {faqs &&
          faqs.map((faq, index) => (
            <FaqItem
              key={faq?._id}
              faq={faq}
              index={index}
              showAnswer={showAnswer}
              toggleAnswer={toggleAnswer}
            />
          ))}
      </div>
    </div>
  );
};

export default FaqList;
